<template>
  <div class="loading-wrapper">
    <div>
      <img src="@/assets/imgs/common/loading.gif" alt="loading" />
      <p>로딩 중입니다.<br />잠시만 기다려주세요.</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.loading-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: $black, $alpha: 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      margin-bottom: 41px;
    }

    p {
      font-size: 24px;
      color: $white;
      text-align: center;
    }
  }
}
</style>
